import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, MessageCircle } from 'lucide-react';

function ContactUs() {
  const navigate = useNavigate();

  return (
    <div className="page" style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem 1rem' }}>
      <button onClick={() => navigate('/')} className="btn btn-ghost" style={{ marginBottom: '2rem' }}>
        <ArrowLeft size={20} style={{ marginRight: '0.5rem' }} /> Back to Home
      </button>

      <h1 style={{ fontSize: '2.5rem', marginBottom: '2rem' }}>Contact Us</h1>
      
      <div className="card" style={{ padding: '2.5rem', marginBottom: '2rem', textAlign: 'center' }}>
        <Mail size={56} color="#00D9FF" style={{ margin: '0 auto 1.5rem' }} />
        <h2 style={{ fontSize: '1.75rem', marginBottom: '1rem' }}>Get in Touch</h2>
        <p style={{ fontSize: '1.125rem', color: '#9CA3AF', marginBottom: '2rem' }}>
          We're here to help with your questions about Astrowins services
        </p>
        
        <div style={{ display: 'inline-block', padding: '1.5rem 2.5rem', background: 'rgba(0, 217, 255, 0.1)', borderRadius: '12px', border: '2px solid #00D9FF' }}>
          <p style={{ fontSize: '0.9375rem', color: '#9CA3AF', marginBottom: '0.5rem' }}>Email us at:</p>
          <a href="mailto:hello@astrowins.in" style={{ fontSize: '1.5rem', fontWeight: 700, color: '#00D9FF', textDecoration: 'none' }}>
            hello@astrowins.in
          </a>
        </div>
      </div>

      <div className="card" style={{ padding: '2rem' }}>
        <h3 style={{ fontSize: '1.5rem', marginBottom: '1.5rem' }}>What We Can Help With:</h3>
        <ul style={{ fontSize: '1rem', lineHeight: 2, color: '#D1D5DB', paddingLeft: '2rem' }}>
          <li>Technical support and account issues</li>
          <li>Questions about your analyses</li>
          <li>Feature requests and feedback</li>
          <li>Billing and subscription queries</li>
          <li>Privacy and data concerns</li>
          <li>Partnership inquiries</li>
        </ul>
      </div>

      <div className="alert alert-info" style={{ marginTop: '2rem' }}>
        <MessageCircle size={20} style={{ display: 'inline', marginRight: '0.5rem' }} />
        <strong>Response Time:</strong> We typically respond within 24-48 hours.
      </div>
    </div>
  );
}

export default ContactUs;